import BIEmbed from './BIEmbed.vue';

export const routes = [
  {
    path: 'apps/bi',
    name: 'apps_bi',
    component: BIEmbed,
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
